//#region Imports

import { NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, TemplateRef, ViewChild } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

//#endregion

@Component({
  selector: 'l-carousel',
  standalone: true,
  templateUrl: './carousel.component.html',
  imports: [
    NgTemplateOutlet,
    IconComponent
  ],
})
export class CarouselComponent implements AfterViewInit, OnChanges {

  //#region Public Properties

  @Input() 
  public items: any[] = [];

  @Input() 
  public itemTemplate!: TemplateRef<any>;

  @ViewChild('track') 
  public track!: ElementRef<HTMLDivElement>;

  public currentIndex: number = 0;
  
  // TODO: Make this responsive based on container width and item width
  public visibleCount: number = 4; 

  public itemFullWidth: number = 0;
  
  @HostListener('window:resize')
  public onResize(): void {
    this.scheduleDimensionsCalculation();
  }

  //#endregion

  //#region Public Getters

  public get maxIndex(): number {
    if (this.items.length <= this.visibleCount) return 0;
    return this.items.length - this.visibleCount;
  }

  //#endregion

  //#region Public Methods

  public ngAfterViewInit(): void {
    this.scheduleDimensionsCalculation();
  }

  public prev(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  public next(): void {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
    }
  }

  public ngOnChanges(): void {
    this.scheduleDimensionsCalculation();
  }

  //#endregion

  //#region Private Methods

  private calculateDimensions(): void {
    const trackEl = this.track?.nativeElement;

    if (!trackEl?.children.length) {
      return;
    }

    const firstItem = trackEl.children[0] as HTMLElement;

    const itemWidth = firstItem.offsetWidth;

    const computedStyle = globalThis.getComputedStyle(trackEl);

    let gapValue = computedStyle.gap || computedStyle.columnGap || '0px';

    if (!gapValue || gapValue === 'normal') {
      gapValue = '0px';
    }

    const gap = Number.parseFloat(gapValue.replace('px', '')) || 0;

    this.itemFullWidth = itemWidth + gap;

    const viewportWidth = trackEl.parentElement?.clientWidth ?? 0;

    if (viewportWidth > 0 && this.itemFullWidth > 0) {
      this.visibleCount = Math.max(1, Math.floor(viewportWidth / this.itemFullWidth));
      this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
    }
  }

  private scheduleDimensionsCalculation(): void {
    globalThis.setTimeout(() => {
      if (this.track?.nativeElement?.children.length) {
        this.calculateDimensions();
      }
    });
  }

  //#endregion

}
